import type {
  AdminWorkspacesResponse,
  SetActiveAdminWorkspaceRequest,
  ShellProfileResponse,
} from '@/shared/shell-api-types';

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Request failed (${response.status})`);
  }

  return (await response.json()) as T;
}

export const shellApi = {
  async getProfile() {
    const response = await fetch('/api/protected/profile', {
      method: 'GET',
      credentials: 'include',
    });

    return parseJson<ShellProfileResponse>(response);
  },

  async listAdminWorkspaces() {
    const response = await fetch('/api/admin/workspaces', {
      method: 'GET',
      credentials: 'include',
    });

    return parseJson<AdminWorkspacesResponse>(response);
  },

  async setActiveAdminWorkspace(payload: SetActiveAdminWorkspaceRequest) {
    const response = await fetch('/api/admin/workspaces/active', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });

    return parseJson<AdminWorkspacesResponse>(response);
  },
};
